export default __webpack_public_path__ + "assets/elCuyo.3ae02f88.jpg";